import { Text } from "@ecco/ui/text";
import { Flex } from "@ecco/ui/flex";
import { ECCOIcon } from "@ecco/ui/ecco-icon";
import { Tooltip } from "@ecco/ui/tooltip";
import { useRef } from "react";
import { useGetOffers } from "@hooks/useGetOffers";
import { useTooltip } from "@ecco/ui/use-tooltip";
import { styles } from "./PromoDescription.styles";

type Props = {
    offerIds: string[];
};

export const PromoDescription = ({ offerIds }: Props) => {
    const tooltipRef = useRef(undefined);

    const { isTooltipOpen, setIsTooltipOpen } = useTooltip({ tooltipRef });

    const offers = useGetOffers({ offerIds });

    if (!offers?.length) return null;

    return offers.map(({ description, disclaimer }, index) => (
        <Flex
            ref={tooltipRef}
            key={`${description}-${index}`}
            gap={2}
            direction="row-reverse"
            justifyContent="flex-end"
            mb={7}
            alignItems="center"
        >
            <Text
                as={"span"}
                fontSize={["mobileBodyTextNormal", "desktopBodyTextNormal"]}
                fontWeight="bold"
                sx={{ ...styles.part }}
            >
                {description}
            </Text>
            {disclaimer && (
                <Tooltip
                    isOpen={isTooltipOpen}
                    hasArrow={false}
                    label={disclaimer}
                    closeOnScroll={true}
                    aria-label={disclaimer}
                    sx={styles.tooltip}
                >
                    <ECCOIcon
                        name="info"
                        onClick={() => setIsTooltipOpen(!isTooltipOpen)}
                        sx={styles.tooltipIcon}
                    />
                </Tooltip>
            )}
        </Flex>
    ));
};
